import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { getUrlToBackendApi, request } from '@services/api';

import { GET_ME_QUERY_KEY } from '@hooks/api/user/use-query-me';

import { config } from '@/config.ts';

import { LoginResponse } from './use-mutation-login';

const REQUEST_URL = '/login_by_site';
const MUTATION_KEY = ['auth', 'register'];

export interface RegisterData {
	phone: string;
	password: string;
	isOfferChecked: boolean;
	currency: string;
	language: string;
	isBonusChecked?: boolean;
}

export const useMutationRegister = (shouldReload?: boolean) => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationKey: MUTATION_KEY,
		mutationFn: async ({
			phone,
			password,
			isOfferChecked,
			language,
			currency,
			isBonusChecked = false
		}: RegisterData) => {
			try {
				const registrationResponse = await axios.post(
					`${config.GR8_URL}/registration/byform`,
					{
						formName: 'LANDING_REGISTRATION',
						phone: phone,
						password: password,
						defaultCurrency: currency,
						selectedLanguage: language,
						isPlayerAgree: isOfferChecked,
						nnBonus: isBonusChecked ? '3' : '0'
					},
					{
						headers: {
							'X-API-KEY': config.API_KEY,
							'Content-Type': 'application/json'
						}
					}
				);

				if (registrationResponse?.data?.accountInfo) {
					const { number, phone: registeredPhone } = registrationResponse.data.accountInfo;

					const loginResponse = await request<LoginResponse>({
						method: 'post',
						url: getUrlToBackendApi(REQUEST_URL).href,
						data: {
							pm_id: number,
							currency,
							phone: registeredPhone
						}
					});

					if (loginResponse?.meta?.access_token && loginResponse?.meta?.refresh_token) {
						localStorage.setItem('auth_token', loginResponse.meta.access_token);
						localStorage.setItem('refresh_token', loginResponse.meta.refresh_token);
					}

					return loginResponse;
				}
			} catch (error) {
				console.error('Registration error:', error);
				throw error;
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: GET_ME_QUERY_KEY });
			shouldReload && navigate('/', { replace: true });
		},
		onError: error => {
			console.error('Error during registration mutation:', error);
		}
	});
};
